{
  "familyId": "TGL-GELD-KORTING",
  "questions": [
    {
      "id": "TGL-GELD-KORTING-001",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een fiets kost €80. Je krijgt 10% korting. Hoeveel korting krijg je?",
      "options": ["€8", "€72", "€10", "€70"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_10pct",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korting berekenen",
            "content": "Korting = percentage × prijs ÷ 100. Hier: 10% van €80 = 10 × 80 ÷ 100 = €8.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: korting = percentage × prijs ÷ 100. Tip: 10% is altijd het getal gedeeld door 10. Stap 1: 10% van €80 = €80 ÷ 10 = €8. Stap 2: je krijgt €8 korting.",
        "distractorExplanations": {
          "0": "Correct! 10% van €80 = €80 ÷ 10 = €8.",
          "1": "Veelgemaakte fout: de nieuwe prijs verwarren met het kortingsbedrag. €72 is de prijs na korting (€80 − €8 = €72), maar de vraag vraagt hoeveel korting je krijgt: €8.",
          "2": "Veelgemaakte fout: het percentage verwarren met het bedrag. 10% van €80 is €8, niet €10. €10 zou kloppen als de prijs €100 was.",
          "3": "Veelgemaakte fout: de nieuwe prijs verkeerd berekenen. €70 zou €10 korting zijn, maar 10% van €80 = €8. Controleer: €80 ÷ 10 = €8."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-002",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een jas kost €60. Je krijgt 20% korting. Wat is de nieuwe prijs?",
      "options": ["€48", "€12", "€40", "€80"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_20pct",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nieuwe prijs na korting",
            "content": "Stap 1: Korting = 20% van €60 = €12. Stap 2: Nieuwe prijs = €60 − €12 = €48.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken eerst het kortingsbedrag, dan trek je het af van de originele prijs. Stap 1: 20% van €60 = 20 × 60 ÷ 100 = €12 korting. Stap 2: nieuwe prijs = €60 − €12 = €48.",
        "distractorExplanations": {
          "0": "Correct! €60 − 20% = €60 − €12 = €48.",
          "1": "Veelgemaakte fout: het kortingsbedrag verwarren met de nieuwe prijs. €12 is hoeveel korting je krijgt, niet wat je betaalt. Je betaalt €60 − €12 = €48.",
          "2": "Veelgemaakte fout: het percentage verkeerd berekenen. €40 zou kloppen bij 33% korting (€60 − €20). Maar 20% van €60 = €12, dus nieuwe prijs = €48.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. €80 = €60 + €20, maar bij korting trek je af. Nieuwe prijs = €60 − €12 = €48."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-003",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een boek kost €25. Je krijgt 10% korting. Hoeveel betaal je?",
      "options": ["€22,50", "€2,50", "€27,50", "€15"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_10pct",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "10% korting op €25",
            "content": "Stap 1: 10% van €25 = €25 ÷ 10 = €2,50. Stap 2: €25 − €2,50 = €22,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: 10% = delen door 10, dan aftrekken van de originele prijs. Stap 1: 10% van €25 = €25 ÷ 10 = €2,50 korting. Stap 2: nieuwe prijs = €25 − €2,50 = €22,50.",
        "distractorExplanations": {
          "0": "Correct! €25 − €2,50 = €22,50.",
          "1": "Veelgemaakte fout: het kortingsbedrag verwarren met de nieuwe prijs. €2,50 is de korting, niet wat je betaalt. Je betaalt €25 − €2,50 = €22,50.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. €27,50 = €25 + €2,50. Bij korting trek je af: €25 − €2,50 = €22,50.",
          "3": "Veelgemaakte fout: het percentage verkeerd inschatten. €15 zou kloppen bij 40% korting (€25 − €10). Maar 10% van €25 is slechts €2,50."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-004",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een spelcomputer kost €120. Je krijgt 25% korting. Hoeveel korting is dat?",
      "options": ["€30", "€90", "€25", "€95"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_25pct",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "25% korting berekenen",
            "content": "25% = een kwart. Een kwart van €120 = €120 ÷ 4 = €30.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: 25% = een kwart, dus deel door 4. Stap 1: 25% van €120 = €120 ÷ 4 = €30 korting.",
        "distractorExplanations": {
          "0": "Correct! 25% van €120 = €120 ÷ 4 = €30.",
          "1": "Veelgemaakte fout: de nieuwe prijs verwarren met het kortingsbedrag. €90 is de prijs na korting (€120 − €30 = €90), maar de vraag vraagt hoeveel korting je krijgt: €30.",
          "2": "Veelgemaakte fout: het percentage verwarren met het bedrag. 25% van €120 is €30, niet €25. Onthoud: 25% = delen door 4, niet het getal 25 zelf.",
          "3": "Veelgemaakte fout: de nieuwe prijs verkeerd berekenen. €95 zou €25 korting zijn, maar 25% van €120 = €120 ÷ 4 = €30."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-005",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een trui kost €40. De winkel geeft 15% korting. Wat betaal je?",
      "options": ["€34", "€6", "€46", "€25"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_15pct",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "15% korting op €40",
            "content": "Stap 1: 10% van €40 = €4. Stap 2: 5% = helft van 10% = €2. Stap 3: 15% = €4 + €2 = €6. Stap 4: €40 − €6 = €34.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits 15% in 10% + 5% voor makkelijker rekenen. Stap 1: 10% van €40 = €4. Stap 2: 5% = helft van 10% = €2. Stap 3: 15% = €4 + €2 = €6 korting. Stap 4: nieuwe prijs = €40 − €6 = €34.",
        "distractorExplanations": {
          "0": "Correct! 15% van €40 = €6 korting. €40 − €6 = €34.",
          "1": "Veelgemaakte fout: het kortingsbedrag verwarren met de nieuwe prijs. €6 is de korting, niet wat je betaalt. Je betaalt €40 − €6 = €34.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. €46 = €40 + €6. Bij korting trek je af: €40 − €6 = €34.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €25 zou kloppen bij 37,5% korting. Maar 15% van €40 = €6, dus nieuwe prijs = €34."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-006",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een tas kost €50. Je krijgt 20% korting. Hoeveel korting krijg je?",
      "options": ["€10", "€40", "€20", "€30"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_20pct",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "20% van €50",
            "content": "20% = een vijfde. Een vijfde van €50 = €50 ÷ 5 = €10.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: 20% = een vijfde, dus deel door 5. Stap 1: 20% van €50 = €50 ÷ 5 = €10 korting.",
        "distractorExplanations": {
          "0": "Correct! 20% van €50 = €50 ÷ 5 = €10.",
          "1": "Veelgemaakte fout: de nieuwe prijs verwarren met het kortingsbedrag. €40 is de prijs na korting (€50 − €10 = €40), maar de vraag vraagt hoeveel korting je krijgt: €10.",
          "2": "Veelgemaakte fout: het percentage verwarren met het bedrag. 20% van €50 is €10, niet €20. Onthoud: 20% = delen door 5.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €15 zou kloppen bij 30% korting. Maar 20% van €50 = €10."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-007",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een winkel verhoogt de prijs met 10% opslag. Een artikel kostte €30. Wat is de nieuwe prijs?",
      "options": ["€33", "€3", "€27", "€40"],
      "correctAnswer": 0,
      "conceptId": "surcharge_10pct",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Opslag berekenen",
            "content": "Opslag = percentage × prijs ÷ 100. Hier: 10% van €30 = €3. Nieuwe prijs = €30 + €3 = €33. Let op: bij opslag tel je erbij op!",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij opslag tel je het percentage erbij op (niet aftrekken!). Stap 1: 10% van €30 = €30 ÷ 10 = €3 opslag. Stap 2: nieuwe prijs = €30 + €3 = €33.",
        "distractorExplanations": {
          "0": "Correct! €30 + 10% = €30 + €3 = €33.",
          "1": "Veelgemaakte fout: het opslagbedrag verwarren met de nieuwe prijs. €3 is de opslag, niet wat je betaalt. Je betaalt €30 + €3 = €33.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. €27 = €30 − €3. Bij opslag (prijsverhoging) tel je erbij op: €30 + €3 = €33.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €40 zou kloppen bij 33% opslag. Maar 10% van €30 = €3, dus nieuwe prijs = €33."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-008",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een restaurant rekent 10% servicekosten bij. De rekening is €45. Hoeveel betaal je in totaal?",
      "options": ["€49,50", "€4,50", "€40,50", "€55"],
      "correctAnswer": 0,
      "conceptId": "surcharge_service",
      "variantIndex": 8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Servicekosten berekenen",
            "content": "10% van €45 = €4,50. Totaal = €45 + €4,50 = €49,50. Servicekosten worden opgeteld bij de rekening.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: servicekosten zijn een opslag — tel het percentage erbij op. Stap 1: 10% van €45 = €45 ÷ 10 = €4,50 servicekosten. Stap 2: totaal = €45 + €4,50 = €49,50.",
        "distractorExplanations": {
          "0": "Correct! €45 + 10% = €45 + €4,50 = €49,50.",
          "1": "Veelgemaakte fout: de servicekosten verwarren met het totaal. €4,50 zijn de servicekosten zelf, niet het totaal. Je betaalt €45 + €4,50 = €49,50.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. €40,50 = €45 − €4,50. Servicekosten komen erbij: €45 + €4,50 = €49,50.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €55 zou kloppen bij 22% opslag. Maar 10% van €45 = €4,50, dus totaal = €49,50."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-009",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een schoenenwinkel geeft 25% korting op alle schoenen. Een paar schoenen kost €80. Wat betaal je?",
      "options": ["€60", "€20", "€105", "€55"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_25pct",
      "variantIndex": 9,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "25% korting op €80",
            "content": "25% = een kwart. €80 ÷ 4 = €20 korting. Nieuwe prijs = €80 − €20 = €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: 25% = een kwart, dus deel door 4, dan aftrekken. Stap 1: 25% van €80 = €80 ÷ 4 = €20 korting. Stap 2: nieuwe prijs = €80 − €20 = €60.",
        "distractorExplanations": {
          "0": "Correct! €80 − 25% = €80 − €20 = €60.",
          "1": "Veelgemaakte fout: het kortingsbedrag verwarren met de nieuwe prijs. €20 is de korting, niet wat je betaalt. Je betaalt €80 − €20 = €60.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. €105 = €80 + €25. Bij korting trek je af: €80 − €20 = €60.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €55 zou kloppen bij 31% korting. Maar 25% van €80 = €20, dus nieuwe prijs = €60."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-010",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een speelgoedwinkel geeft 20% korting. Een speelgoedauto kost €35. Hoeveel korting krijg je?",
      "options": ["€7", "€28", "€20", "€15"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_20pct_odd",
      "variantIndex": 10,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "20% van €35",
            "content": "20% = een vijfde. €35 ÷ 5 = €7 korting.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: 20% = een vijfde, dus deel door 5. Stap 1: 20% van €35 = €35 ÷ 5 = €7 korting.",
        "distractorExplanations": {
          "0": "Correct! 20% van €35 = €35 ÷ 5 = €7.",
          "1": "Veelgemaakte fout: de nieuwe prijs verwarren met het kortingsbedrag. €28 is de prijs na korting (€35 − €7 = €28), maar de vraag vraagt hoeveel korting je krijgt: €7.",
          "2": "Veelgemaakte fout: het percentage verwarren met het bedrag. 20% van €35 is €7, niet €20. Onthoud: 20% = delen door 5.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €15 zou kloppen bij 43% korting. Maar 20% van €35 = €7."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-011",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een telefoon kost €200. De winkel geeft 15% korting. Wat is de nieuwe prijs?",
      "options": ["€170", "€30", "€230", "€185"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_15pct_large",
      "variantIndex": 11,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "15% korting op €200",
            "content": "10% van €200 = €20. 5% = €10. Totaal: 15% = €30 korting. Nieuwe prijs = €200 − €30 = €170.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits 15% in 10% + 5% voor makkelijker rekenen. Stap 1: 10% van €200 = €20. Stap 2: 5% = helft van 10% = €10. Stap 3: 15% = €20 + €10 = €30 korting. Stap 4: nieuwe prijs = €200 − €30 = €170.",
        "distractorExplanations": {
          "0": "Correct! €200 − 15% = €200 − €30 = €170.",
          "1": "Veelgemaakte fout: het kortingsbedrag verwarren met de nieuwe prijs. €30 is de korting, niet wat je betaalt. Je betaalt €200 − €30 = €170.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. €230 = €200 + €30. Bij korting trek je af: €200 − €30 = €170.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €185 zou kloppen bij 7,5% korting (€15). Maar 15% van €200 = €30, dus nieuwe prijs = €170."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-012",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een concert verhoogt de ticketprijs met 20% opslag. Een ticket kostte €50. Wat is de nieuwe prijs?",
      "options": ["€60", "€10", "€40", "€70"],
      "correctAnswer": 0,
      "conceptId": "surcharge_20pct",
      "variantIndex": 12,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "20% opslag op €50",
            "content": "20% van €50 = €10 opslag. Nieuwe prijs = €50 + €10 = €60. Bij opslag tel je erbij op.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij opslag tel je het percentage erbij op. 20% = een vijfde, dus deel door 5. Stap 1: 20% van €50 = €50 ÷ 5 = €10 opslag. Stap 2: nieuwe prijs = €50 + €10 = €60.",
        "distractorExplanations": {
          "0": "Correct! €50 + 20% = €50 + €10 = €60.",
          "1": "Veelgemaakte fout: het opslagbedrag verwarren met de nieuwe prijs. €10 is de opslag, niet wat je betaalt. Je betaalt €50 + €10 = €60.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. €40 = €50 − €10. Bij opslag (prijsverhoging) tel je erbij op: €50 + €10 = €60.",
          "3": "Veelgemaakte fout: het percentage verkeerd berekenen. €70 zou kloppen bij 40% opslag. Maar 20% van €50 = €10, dus nieuwe prijs = €60."
        }
      }
    }
  ]
}